import { createPromiseClient } from "@apachedubbo/dubbo";
import { TriCompanyService } from "@onetakesolutions/cargogo-contract-web/TriCompanyService_dubbo";
import transport from "./transport";

const client = createPromiseClient(TriCompanyService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
